// 📍 화면 모서리 배치 클래스 — 개인설정 '데스크톱 알림 위치'(NotifDesktopPos 6종)를 앱 안 고정 요소(통화 도크·수신 벨 카드)에도 같은 규칙으로
//   (2026-09-04 원격 "보이스톡 울릴 때 우측하단에 나오는데 알림 위치 설정처럼 동일한 위치로(앱·데탑)").
//   데스크톱 알림 팝업(Tauri 창)은 desktop/notification.popupPosition 이 좌표로, 앱 안 요소는 이 클래스로 — 값의 정본은 prefs.NotifDesktopPos 하나.
import type { NotifDesktopPos } from '../api/prefs';

/** fixed 요소용 Tailwind 클래스. 모바일(기본)은 하단 탭바 위(bottom-24)·상단 헤더 아래(top-16), md+ 는 가장자리 6. */
export function cornerClass(pos: NotifDesktopPos): string {
	const [v, h] = pos.split('-') as ['top' | 'bottom', 'left' | 'right' | 'center'];
	const y = v === 'top' ? 'top-16 md:top-6' : 'bottom-24 md:bottom-6';
	const x = h === 'left' ? 'left-3 md:left-6' : h === 'right' ? 'right-3 md:right-6' : 'left-1/2 -translate-x-1/2';
	return `fixed ${y} ${x}`;
}
